import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { StoragePlace } from '../storage-place';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Storage } from '../../storage/storage';
import { StoragePlaceService } from '../storage-place.service';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';

@Component({
    selector: 'kiene-add-storage-place-dialog',
    templateUrl: './add-storage-place-dialog.component.html',
    styleUrls: ['./add-storage-place-dialog.component.scss'],
})
export class AddStoragePlaceDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<AddStoragePlaceDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private storageService: StoragePlaceService,
    ) {}

    nameCtrl = new UntypedFormControl('', [Validators.required]);
    storageCtrl = new UntypedFormControl('', [Validators.required]);
    storages: Storage[] = [];

    ngOnInit() {
        this.loadStorages();
    }

    loadStorages() {
        this.storageService.getLagers().subscribe(storages => {
            this.storages = storages.records;
        });
    }

    storageComparator(one: Storage, two: Storage): boolean {
        return KieneUtils.sameId(one?.lager_id, two?.lager_id);
    }

    create() {
        const storagePlace = new StoragePlace();
        storagePlace.bezeichnung = this.nameCtrl.value;
        storagePlace.lager_id = this.storageCtrl.value.lager_id;
        this.dialogRef.close(storagePlace);
    }

    cancel() {
        this.dialogRef.close(null);
    }
}
